<script setup lang="ts">
import { ModalDefault } from '@shared/ui/modals'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useModalDisciplineScheduleAssign } from '../../model/modal-discipline-schedule-assign.hook'
import DisciplineScheduleTutors from '../DisciplineScheduleTutors.vue'

defineOptions({
  name: 'ModalDisciplineScheduleAssign',
})

const {
  refRows,
  refIsLoading,
  refIsDisabled,
  isChosen,
  choose,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleAssign()
</script>

<template>
  <ModalDefault
    show
    title="Assign tutor"
    :loading="refIsLoading"
    class-name="modal-discipline-schedule-tutors"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <DisciplineScheduleTutors
      v-if="!refIsLoading"
      :rows="refRows"
      :is-chosen="isChosen"
      @click:choose="choose"
    />
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        :disabled="refIsDisabled"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
